import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL as string
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string

if (!url || !key) {
  console.error(
    'Missing Supabase environment variables. ' +
    'Copy web/.env.example → web/.env and fill in your project values.'
  )
}

function getSessionId(): string {
  let id = localStorage.getItem('neptam_session_id')
  if (!id) {
    id = crypto.randomUUID()
    localStorage.setItem('neptam_session_id', id)
  }
  return id
}

// Send session ID as a header on every request so RLS can enforce
// that DELETE/UPDATE on votes only affects the session that owns the row.
export const supabase = createClient(url, key, {
  global: {
    headers: { 'x-session-id': getSessionId() },
  },
})
